import { ProductPromotion } from 'src/components/ProductDetail/utils/product-detail.types';
import { productDetail_productDetail_items_pdp_sales_rules_rules } from 'src/queries/__generated__/productDetail';

/**
 * Cleans the product promotions data from the GraphQL query response.
 * @param promotions
 */
export function cleanProductPromotions(
    promotions: (productDetail_productDetail_items_pdp_sales_rules_rules | null)[] | null | undefined,
): ProductPromotion[] | undefined {
    if (!promotions) {
        return undefined;
    }

    return promotions?.map((promotion) => {
        return {
            pdpDescription: promotion?.pdp_description ?? undefined,
            pdpLabel: promotion?.pdp_label ?? undefined,
            pdpLink: promotion?.pdp_link ?? undefined,
            pdpLinkText: promotion?.pdp_link_text ?? undefined,
            pdpLinkBackground: promotion?.pdp_link_background ?? undefined,
            pdpLinkTextColour: promotion?.pdp_link_text_colour ?? undefined,
            pdpTermsAndConditions: promotion?.pdp_terms_and_conditions ?? undefined,
            ruleId: promotion?.rule_id ?? undefined,
        };
    });
}
